import React from 'react'
import logo from '../../../assets/img/logo/logo-drone.svg'
import { Link } from 'react-router-dom'

const SidebarLogo = () => {
  return (
    <div className="sidebar__logo">
        <Link to="/">
            <img src={logo} alt="Логотип" />
        </Link>
    </div>
  )
}

export default SidebarLogo